import { PRO_WORLDS, PRO_TOTAL } from "../../data/proWorlds";
import { computeHealth, getMonthLabel } from "../../data/budgetCats";

export default function ProDashboard({ progress, onSelect, budgetData, onOpenBudget }: any) {
  const done=Object.keys(progress).length;
  const pct=Math.round(done/PRO_TOTAL*100);
  const today = new Date().toISOString().slice(0, 7);
  const monthData  = budgetData?.months?.[today];
  const health     = monthData ? computeHealth(monthData.categories) : null;
  const STATUS: Record<string, { bar: string; text: string; label: string }> = {
    good:  { bar: "#16a34a", text: "#4ade80", label: "✅ On Track"      },
    close: { bar: "#d97706", text: "#fbbf24", label: "⚠️ Getting Close" },
    over:  { bar: "#dc2626", text: "#f87171", label: "🚨 Over Budget"   },
  };
  return(
    <div style={{fontFamily:"Nunito",background:"#0f172a",minHeight:"100vh",paddingBottom:100}}>
      {/* Hero */}
      <div style={{background:"linear-gradient(135deg,#1e3a5f,#0f172a)",padding:"24px 18px 20px",borderBottom:"1px solid #1e293b"}}>
        <div style={{fontSize:11,color:"#64748b",fontWeight:800,textTransform:"uppercase",letterSpacing:3,marginBottom:4}}>Young Adult Edition</div>
        <div style={{fontSize:26,fontWeight:900,color:"#f1f5f9",fontFamily:"Fredoka One",lineHeight:1.1,marginBottom:4}}>Make Money Work For You 💼</div>
        <div style={{fontSize:13,color:"#64748b",fontWeight:700,marginBottom:14}}>Portfolio · Real Estate · Tax Strategy · Career</div>
        <div style={{background:"#1e293b",borderRadius:20,height:8,overflow:"hidden",marginBottom:4}}>
          <div style={{height:"100%",background:"linear-gradient(90deg,#0ea5e9,#8b5cf6)",borderRadius:20,
            width:`${pct}%`,transition:"width 0.6s"}}/>
        </div>
        <div style={{fontSize:12,color:"#475569",fontWeight:700}}>{done}/{PRO_TOTAL} lessons · {pct}% complete</div>
      </div>

      {/* Budget health mini-card */}
      <div style={{ padding: "14px 18px 0" }}>
        <button onClick={onOpenBudget} style={{ width: "100%", background: "#1e293b", border: health ? `1.5px solid ${STATUS[health.status].bar}44` : "1.5px solid #334155", borderRadius: 16, padding: "12px 14px", cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ fontSize: 26 }}>📊</div>
          {health ? (
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 5 }}>
                <div style={{ fontSize: 13, fontWeight: 900, color: "#f1f5f9", fontFamily: "Fredoka One" }}>{getMonthLabel(today)} Budget</div>
                <div style={{ fontSize: 11, fontWeight: 900, color: STATUS[health.status].text }}>{STATUS[health.status].label}</div>
              </div>
              <div style={{ background: "#0f172a", borderRadius: 20, height: 5, overflow: "hidden" }}>
                <div style={{ width: `${Math.min(100, health.pct)}%`, height: "100%", background: STATUS[health.status].bar, borderRadius: 20 }} />
              </div>
              <div style={{ fontSize: 10, fontWeight: 800, color: "#475569", marginTop: 4 }}>
                ${health.totalActual.toLocaleString()} spent of ${health.totalBudget.toLocaleString()} budget
              </div>
            </div>
          ) : (
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 900, color: "#f1f5f9", fontFamily: "Fredoka One" }}>Budget vs. Actual</div>
              <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700 }}>Tap to set up this month's budget →</div>
            </div>
          )}
        </button>
      </div>

      {/* World cards */}
      <div style={{padding:"16px",display:"flex",flexDirection:"column",gap:12}}>
        {PRO_WORLDS.map(w=>{
          const d=w.lessons.filter((_,i)=>progress[`${w.id}-${i}`]).length;
          const p=d/w.lessons.length;
          return(
            <button key={w.id} onClick={()=>onSelect(w.id)} className="btn-bounce"
              style={{background:"#1e293b",border:`2px solid ${w.color}33`,borderRadius:20,
                padding:0,cursor:"pointer",textAlign:"left",overflow:"hidden",
                boxShadow:`0 4px 16px ${w.color}22`,transition:"all 0.2s"}}>
              <div style={{padding:"16px"}}>
                <div style={{display:"flex",gap:14,alignItems:"center"}}>
                  <div style={{fontSize:40,lineHeight:1,flexShrink:0}}>{w.emoji}</div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:10,color:w.color,fontWeight:800,textTransform:"uppercase",letterSpacing:1.5,marginBottom:2}}>{w.tag}</div>
                    <div style={{fontSize:17,fontWeight:900,color:"#f1f5f9",marginBottom:6,fontFamily:"Fredoka One"}}>{w.label}</div>
                    <div style={{background:"#0f172a",borderRadius:20,height:6,overflow:"hidden"}}>
                      <div style={{width:`${p*100}%`,height:"100%",background:w.color,borderRadius:20,transition:"width 0.5s"}}/>
                    </div>
                    <div style={{marginTop:4,fontSize:11,color:w.color,fontWeight:700}}>{d}/{w.lessons.length} lessons</div>
                  </div>
                  {p===1&&<div style={{fontSize:20}}>⭐</div>}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
